<template>
  <el-scrollbar>
    <div class="view-modal window-scorll">
      <div class="star">
        <div class="block">
          <span class="demonstration">默认不区分颜色</span>
          <el-rate v-model="value1"></el-rate>
        </div>
        <div class="block">
          <span class="demonstration">区分颜色</span>
          <el-rate
            v-model="value2"
            :colors="['#99A9BF', '#F7BA2A', '#FF9900']">
          </el-rate>
        </div>
        <div class="block">
        <span class="demonstration">显示文字</span>
          <el-rate
            v-model="value3"
            :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
            show-text>
          </el-rate>
        </div>
        <div class="block">
        <span class="demonstration">icon</span>
          <el-rate
              v-model="value4"
              :icon-classes="['el-icon-circle-plus', 'el-icon-remove-outline', 'el-icon-circle-plus-outline']"
              void-icon-class="el-icon-remove"
              :colors="['#99A9BF', '#F7BA2A', '#FF9900']">
            </el-rate>
        </div>
        <div class="block">
          <span class="demonstration">只读</span>
          <el-rate
            v-model="value5"
            disabled
            show-score
            text-color="#ff9900"
            score-template="{value}">
          </el-rate>
        </div>
        <hr>
        <div class="tag">
          <el-tag>标签一</el-tag>
          <el-tag size="medium" type="success">标签二</el-tag>
          <el-tag size="small" type="info">标签三</el-tag>
          <el-tag size="mini" type="warning">标签四</el-tag>
          <el-tag type="danger">标签五</el-tag>
          <el-tag closable>标签</el-tag>
          <br>
          <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)"> {{tag}} </el-tag>
          <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
        </div>
        <hr>
        <div class="progress">
          <el-progress :percentage="0"></el-progress>
          <el-progress :percentage="70"></el-progress>
          <el-progress :percentage="80" color="#8e71c7"></el-progress>
          <el-progress :percentage="progress_bar.num" :status="progress_bar.status"></el-progress>
          <el-progress :percentage="50" status="exception"></el-progress>
        </div>
        <div class="progress">
          <el-progress :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
          <el-progress :text-inside="true" :stroke-width="18" :percentage="70"></el-progress>
          <el-progress :text-inside="true" :stroke-width="18" :percentage="80" color="rgba(142, 113, 199, 0.7)"></el-progress>
          <el-progress :text-inside="true" :stroke-width="18" :percentage="progress_bold_bar.num" :status="progress_bold_bar.status"></el-progress>
          <el-progress :text-inside="true" :stroke-width="18" :percentage="50" status="exception"></el-progress>
        </div>
        <div class="progress">
          <el-progress type="circle" :percentage="0"></el-progress>
          <el-progress type="circle" :percentage="25"></el-progress>
          <el-progress type="circle" :percentage="80" color="#8e71c7"></el-progress>
          <el-progress type="circle" :percentage="progress.num" :status="progress.status"></el-progress>
          <el-progress type="circle" :percentage="50" status="exception"></el-progress>
        </div>
        <div class="mt-20">
          <div>import 'element-ui/lib/theme-chalk/index.css';</div>
          <br>
          <h3>整体引入elementui插件</h3>
          <br>
          <div>import ElementUI from 'element-ui';</div>
          <br>
          <h3>单独引入elementui插件</h3>
          <table :class="$style.table">
            <tbody>
              <tr v-for="(b,index) in el_table.b">
                <td v-for="(bb, i) in b"><span :class="index > 0 && index < (el_table.b.length-1) && i === 0 ? 'ml-20 mr-20' : ''"></span>{{ bb }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </el-scrollbar>
</template>
<script>
  export default {
    data() {
      return {
        value1: 3.2,
        value2: null,
        value3: null,
        value4: null,
        value5: 3.7,
        dynamicTags: ['标签一', '标签二', '标签三'],
        inputVisible: false,
        inputValue: '',
        progress:{
          num:0,
          status:'exception',
        },
        progress_bar:{
          num:0,
          status:'exception',
        },
        progress_bold_bar:{
          num:0,
          status:'exception',
        },
        el_table:{
          b:[
            ["import {", ""],
            ["    Row,", "Vue.use(Row)"],
            ["    Col,", "Vue.use(Col)"],
            ["    Icon,", "Vue.use(Icon)"],
            ["    Button,", "Vue.use(Button)"],
            ["    Radio,", "Vue.use(Radio)"],
            ["    RadioGroup,", "Vue.use(RadioGroup)"],
            ["    Checkbox,", "Vue.use(Checkbox)"],
            ["    CheckboxGroup,", "Vue.use(CheckboxGroup)"],
            ["    Input,", "Vue.use(Input)"],
            ["    Select,", "Vue.use(Select)"],
            ["    Option,", "Vue.use(Option)"],
            ["    TimePicker,", "Vue.use(TimePicker)"],
            ["    DatePicker,", "Vue.use(DatePicker)"],
            ["    Form,", "Vue.use(Form)"],
            ["    FormItem,", "Vue.use(FormItem)"],
            ["    Table,", "Vue.use(Table)"],
            ["    TableColumn,", "Vue.use(TableColumn)"],
            ["    Progress,", "Vue.use(Progress)"],
            ["    Pagination,", "Vue.use(Pagination)"],
            ["    Alert,", "Vue.use(Alert)"],
            ["    Loading,", "Vue.use(Loading)"],
            ["    Message,", "Vue.use(Message)"],
            ["    MessageBox,", "Vue.use(MessageBox)"],
            ["    Notification,", "Vue.use(Notification)"],
            ["    Menu,", "Vue.use(Menu)"],
            ["    Submenu,", "Vue.use(Submenu)"],
            ["    MenuItem,", "Vue.use(MenuItem)"],
            ["    Breadcrumb,", "Vue.use(Breadcrumb)"],
            ["    BreadcrumbItem,", "Vue.use(BreadcrumbItem)"],
            ["    Dialog,", "Vue.use(Dialog)"],
            ["} from 'element-ui'", ""],
          ]
        }
      }
    },
    methods:{
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      ProgressAnimate(data,num){
        let _data = data;
        let t = setInterval(() => {
          if(_data.num >= num){
            if(_data.num === 100) {
              _data.status = 'success';
            }
            clearInterval(t);
            return;
          }else{
            _data.num++;
          }
        },10)
      }
    },
    mounted(){
      this.ProgressAnimate(this.progress_bar,100);
      this.ProgressAnimate(this.progress_bold_bar,100);
      this.ProgressAnimate(this.progress,100);
      this.$parent.main_header_active = false;
    },
    created(){
        this.$parent.routerLoading();
    },
  }
</script>
<style module>
  .table{
    width: 100%;
  }
</style>
<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>


// WEBPACK FOOTER //
// src/components/main-content/star-tag-progress.vue